import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { gridConfig } from './grid-config';

const { forwardRef } = React;

const propTypes = {
	dataTestId: PropTypes.string,
};
const defaultProps = {
	dataTestId: null,
};

const StyledComponent = styled.div`
	display: grid;
	padding: 0 ${gridConfig.xxs.margin};
	place-items: center;

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		padding: 0 ${gridConfig.m.margin};
	}
`;

const GridContainer = forwardRef(({ dataTestId, ...props }, ref) => (
	<StyledComponent
		className="fuse-responsive-grid__container"
		data-testid={dataTestId}
		ref={ref}
		{...props}
	/>
));

GridContainer.propTypes = propTypes;
GridContainer.defaultProps = defaultProps;
GridContainer.displayName = 'GridContainer';

export default GridContainer;
